exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".body-mobile-friendly {\n  background-color: #fff;\n}\n@media (min-width: 460px) {\n  .body-mobile-friendly {\n    background-color: #fafafa;\n  }\n}\n", ""]);
